export const Logo = ({ className = "h-12 w-12" }) => (
  <img src="/logo.png" alt="Sempresera logo" className={`${className} shrink-0 object-contain`} />
);

export const Wordmark = () => (
  <span
    className="font-display text-3xl font-black tracking-tight md:text-4xl"
    style={{
      background: "linear-gradient(160deg, #F8FBFE 0%, #C3D3E2 28%, #7C93AB 48%, #2EA9DC 72%, #A8C8E4 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      filter: "drop-shadow(0 1px 2px rgba(4, 146, 202, 0.35))",
    }}
  >
    Sempresera
  </span>
);
